import styled from 'styled-components';
import { PageProps } from './Page';

export const PageWrapper = styled.div<PageProps>`
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
`;

export const Main = styled.main<PageProps>`
  flex-grow: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
